export const faqHeaderBgImage = require('assets/images/faq/faqHeaderBg.webp');
export const faqServiceImage = require('assets/images/faq/faqService.webp');
